/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The SensorResponse model module.
* @module model/SensorResponse
* @version 2020-12-7
*/
export default class SensorResponse {
    /**
    * Constructs a new <code>SensorResponse</code>.
    * センサー
    * @alias module:model/SensorResponse
    * @class
    * @param id {Number} ID
    * @param assignStatus {Number} 割当状態
    * @param installStatus {Number} 取付状態
    * @param activateStatus {Number} アクティベート状態
    * @param serialNo {String} シリアル番号
    * @param sensorId {String} センサーID
    * @param sensorType {Number} センサータイプ
    */

    constructor(id, assignStatus, installStatus, activateStatus, serialNo, sensorId, sensorType) {
        
        
        this['id'] = id;
        this['assignStatus'] = assignStatus;
        this['installStatus'] = installStatus;
        this['activateStatus'] = activateStatus;
        this['serialNo'] = serialNo;
        this['sensorId'] = sensorId;
        this['sensorType'] = sensorType;
        
    }

    /**
    * Constructs a <code>SensorResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SensorResponse} obj Optional instance to populate.
    * @return {module:model/SensorResponse} The populated <code>SensorResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SensorResponse();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('assignStatus')) {
                obj['assignStatus'] = ApiClient.convertToType(data['assignStatus'], 'Number');
            }
            if (data.hasOwnProperty('installStatus')) {
                obj['installStatus'] = ApiClient.convertToType(data['installStatus'], 'Number');
            }
            if (data.hasOwnProperty('activateStatus')) {
                obj['activateStatus'] = ApiClient.convertToType(data['activateStatus'], 'Number');
            }
            if (data.hasOwnProperty('serialNo')) {
                obj['serialNo'] = ApiClient.convertToType(data['serialNo'], 'String');
            }
            if (data.hasOwnProperty('sensorId')) {
                obj['sensorId'] = ApiClient.convertToType(data['sensorId'], 'String');
            }
            if (data.hasOwnProperty('sensorType')) {
                obj['sensorType'] = ApiClient.convertToType(data['sensorType'], 'Number');
            }
            if (data.hasOwnProperty('tankId')) {
                obj['tankId'] = ApiClient.convertToType(data['tankId'], 'Number');
            }
            if (data.hasOwnProperty('tankOwnerId')) {
                obj['tankOwnerId'] = ApiClient.convertToType(data['tankOwnerId'], 'Number');
            }
        }
        return obj;
    }

    /**
    * ID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * 割当状態
    * @member {Number} assignStatus
    */
    'assignStatus' = undefined;
    /**
    * 取付状態
    * @member {Number} installStatus
    */
    'installStatus' = undefined;
    /**
    * アクティベート状態
    * @member {Number} activateStatus
    */
    'activateStatus' = undefined;
    /**
    * シリアル番号
    * @member {String} serialNo
    */
    'serialNo' = undefined;
    /**
    * センサーID
    * @member {String} sensorId
    */
    'sensorId' = undefined;
    /**
    * センサータイプ
    * @member {Number} sensorType
    */
    'sensorType' = undefined;
    /**
    * タンクID
    * @member {Number} tankId
    */
    'tankId' = undefined;
    /**
    * タンク所有者ID
    * @member {Number} tankOwnerId
    */
    'tankOwnerId' = undefined;




}
